export const brandFamiliesApiHandler = async input => {
  return await fetch(`api/retailer/brand_families?search=${input}`).then(res => {
    return { data: res.json() };
  });
};

export const productLinesApiHandler = async input => {
  return await fetch(`api/retailer/product_lines?search=${input}`).then(res => {
    return { data: res.json() };
  });
};
